import React from 'react';
import SalesListing from '../modules/SalesListing';

function SalesPage(){
  return <SalesListing/>
}

export default SalesListing;
